import { getDefaultParameters } from "@/utils";
import { useNewNavigate } from "@shared/client";
import { usePostBookingConfirm } from "@shared/server";

export const useGetIMPResponse = () => {
    const { onNavigate } = useNewNavigate();
    // const idx = getDefaultParameters().idx;
    const { mutate } = usePostBookingConfirm();
    const requestToServerFormData = (orderNum: any) => {
        const responseIMP = async (response: any) => {
            const { success, imp_uid, error_msg } = response;
            if (success) {
                const successData = {
                    co_id: getDefaultParameters().co_id,
                    // idx: Number(idx),
                    imp_uid,
                    status: "complete",
                    orderNum,
                };
                mutate(successData, {
                    onSuccess: (res) => {
                        sessionStorage.setItem(`${orderNum}`, JSON.stringify(res));
                        onNavigate({ path: "/complete", params: { orderNum } });
                    },
                });
            }
            if (error_msg) {
                alert(error_msg);
                const errorData = {
                    co_id: getDefaultParameters().co_id,
                    // idx: Number(idx),
                    status: "error",
                    orderNum,
                };
                mutate(errorData, {
                    onSuccess: () => {
                        return;
                    },
                });
            }
        };

        return { responseIMP };
    };

    return { requestToServerFormData };
};
